exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-info[data-v-6174f863]{font-size:smaller}.char-count[data-v-6174f863]{color:#006400}.char-count-close[data-v-6174f863]{color:#ff4500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6174f863","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/EditNotebookDialog.vue
// module id = 180
// module chunks = 0